
//*****************************************************
// <auto-generated>
//   Generated by the cybtans protocol buffer compiler.  DO NOT EDIT!
//   Powered By Cybtans    
// </auto-generated>
//******************************************************


export interface AlbumDto {
  userId?: string|null;
  coverId?: string|null;
  tags?: string|null;
  coverUrl?: string|null;
  tenantId?: string|null;
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}


export interface GroupDto {
  permissions?: string[]|null;
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}


export interface MediaDto {
  albumId?: string|null;
  mediaType: MediaType;
  url?: string|null;
  contentType?: string|null;
  sizeInBytes: number;
  tags?: string|null;
  lods?: MediaLodDto[]|null;
  userId?: string|null;
  tenantId?: string|null;
  poster?: PosterDto|null;
  isMpegDashVideo?: boolean;
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}



export enum MediaType {
  none = 0,
  image = 1,
  video = 2,
  scene3D = 3,
  imageCube = 4,
}



export interface MediaLodDto {
  lodLevel: number;
  sizeInBytes: number;
  url?: string|null;
}


export interface PosterDto {
  url?: string|null;
  contentType?: string|null;
  sizeInBytes: number;
  width: number;
  height: number;
}


export interface TenantDto {
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}


export interface UserDto {
  firstLastName?: string|null;
  secondLastName?: string|null;
  email?: string|null;
  lastLoginDate?: string|Date|null;
  role?: string|null;
  tenantId?: string|null;
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}


export interface UserGroupDto {
  userId?: string|null;
  groupId?: string|null;
  id?: string|null;
  name?: string|null;
  description?: string|null;
  createdDate?: string|Date;
  modifiedDate?: string|Date|null;
}


export interface UserTenantDto {
  id?: string|null;
  userId?: string|null;
  tenantId?: string|null;
  createTime: string|Date;
  role?: string|null;
  restricted: boolean;
}


export interface AlbumRequest {
  id?: string|null;
}


export interface AlbumByNameRequest {
  name?: string|null;
}


export interface UpdateRequest {
  id?: string|null;
  data?: { [key:string]: any }|null;
}


export interface ListAlbumRequest {
  page?: number|null;
  pageSize?: number|null;
  name?: string|null;
}


export interface ListAlbumReply {
  items?: AlbumDto[]|null;
  totalItems: number;
  totalPages: number;
  page: number;
}


export interface ShareAlbumRequest {
  albumId?: string|null;
  email?: string|null;
  role?: string|null;
}


export interface MediaRequest {
  id?: string|null;
}


export interface ListMediaRequest {
  page?: number|null;
  pageSize?: number|null;
  name?: string|null;
  albumId?: string|null;
}


export interface ListMediaReply {
  items?: MediaDto[]|null;
  totalItems: number;
  totalPages: number;
  page: number;
}


export interface UploadContentRequest {
  /** Post Id */
  id: string;
  /** Image content  bytes */
  content: Blob;
  /** Image mime type. For example: image/png image/jpeg, image/webp, video/mp4 */
  contentType: string;
  mediaType?: MediaType|null;
  size: number;
}


export interface ContentRequest {
  id?: string|null;
  lodLevel?: number|null;
}


export interface ContentReply {
  content?: Blob|null;
  contentType?: string|null;
  size: number;
  name?: string|null;
}


export interface TokenRequest {
  clientId?: string|null;
  clientSecret?: string|null;
  grandType: string;
  username?: string|null;
  password?: string|null;
  refreshToken?: string|null;
  code?: string|null;
}


export interface TokenReply {
  access_token?: string|null;
  expires_in: number;
  token_type?: string|null;
  refresh_token?: string|null;
}


/** Json Web Token Key */
export interface JwtkModel {
  kty?: string|null;
  use?: string|null;
  kid?: string|null;
  e?: string|null;
  n?: string|null;
  alg?: string|null;
  x5t?: string|null;
  x5c?: string[]|null;
}


/** Jwtk Set */
export interface JwtkSetResponse {
  keys?: JwtkModel[]|null;
}


export interface AuthCodeRequest {
  email: string;
}


export interface AuthCodeResponse {
  code?: string|null;
  url?: string|null;
}


export interface DeviceTokenResponse {
  code?: string|null;
}


export interface AuthorizeDeviceCodeRequest {
  code?: string|null;
}


export interface RegisterRequest {
  email: string;
  password: string;
  name?: string|null;
  firstLastName?: string|null;
  secondLastName?: string|null;
}


export interface ListTenantUserRequest {
  page?: number|null;
  pageSize?: number|null;
  search?: string|null;
}


export interface UpdateUserRequest {
  name?: string|null;
  firstLastName?: string|null;
  secondLastName?: string|null;
  password?: string|null;
}


export interface TenantUserResponse {
  items?: UserDto[]|null;
  totalItems: number;
  totalPages: number;
  page: number;
  tenantId?: string|null;
}


export interface InviteUserRequest {
  email: string;
  role: string;
  albums?: string[]|null;
}


export interface CreateTenantRequest {
  name?: string|null;
  description?: string|null;
}


export interface UpdateTenantRequest {
  id?: string|null;
  name?: string|null;
  description?: string|null;
}


export interface TenantRequest {
  id?: string|null;
}


export interface UserTenantListDto {
  items?: UserTenantItemDto[]|null;
  totalItems: number;
  totalPages: number;
  page: number;
}


export interface ListTenantsRequest {
  page?: number|null;
  pageSize?: number|null;
}


export interface UserTenantItemDto {
  id?: string|null;
  name?: string|null;
  role?: string|null;
}
